export default function MobileFormField({ label, error, children }) {
  return (
    <div className="mb-4">
      {label ? (
        <label className="mb-1 block text-sm font-medium text-laranjinha">{label}</label>
      ) : null}
      {children}
      {error ? <p className="mt-1 text-sm text-red-400">{error}</p> : null}
    </div>
  );
}
